module.exports = __webpack_public_path__ + "img/coming-soon.255c7e7e.png";